import axios from 'axios';

let globalUser: any = null;

export const setAssetServiceUserContext = (user: any) => {
  globalUser = user;
};

const assetServiceApiInstance = axios.create({
  baseURL: process.env.REACT_APP_ASSET_SERVICE_SERVER_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

assetServiceApiInstance.interceptors.request.use(
  (config) => {
    if (globalUser) {
      config.headers['x-company-code'] = globalUser.company_code;
      config.headers['x-financial-year'] = globalUser.financial_year;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default assetServiceApiInstance;
